import React from "react";
import hipladeTemplate from "../../common/template";
import CsvPreview from "../components/CsvPreview";

function UsersImportPreview() {
  return <CsvPreview />;
}

export default hipladeTemplate(UsersImportPreview);
